'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagPickerOption_unstable", {
    enumerable: true,
    get: function() {
        return useTagPickerOption_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _reactcombobox = require("@fluentui/react-combobox");
const useTagPickerOption_unstable = (props, ref)=>{
    const optionState = (0, _reactcombobox.useOption_unstable)(props, ref);
    const state = {
        components: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ...optionState.components,
            media: 'div',
            secondaryContent: 'span'
        },
        media: _reactutilities.slot.optional(props.media, {
            elementType: 'div'
        }),
        secondaryContent: _reactutilities.slot.optional(props.secondaryContent, {
            elementType: 'span'
        }),
        root: _reactutilities.slot.always({
            ...optionState.root,
            role: 'option',
            'aria-checked': props['aria-checked']
        }, {
            elementType: 'div'
        })
    };
    return state;
};
